import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, CreditCard, Lock, XCircle } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="w-full bg-court-night" data-id="element-33" data-mp="28tuwyyf555f7">
      {/* SECTION 1 - HERO */}
      <section className="relative pt-8 sm:pt-16 pb-12 sm:pb-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-34" data-mp="28vzbeaao1mtq">
        <div className="relative z-10 flex flex-col items-center text-center" data-id="element-35" data-mp="30lauvom5eekq">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-center w-full" data-id="element-36" data-mp="30new1ysnwzhb">
            {/* Brand label */}
            <div className="flex items-center gap-2 mb-5 sm:mb-8" data-id="element-37" data-mp="3kacu70qkbc2w">
              <span className="text-lg" data-id="element-38" data-mp="2ff8tqs6ui4uw">🎾</span>
              <span className="text-cyan-400 font-heading font-bold text-sm sm:text-base tracking-[0.25em] uppercase" data-id="element-39" data-mp="2fg1rx4rqnm1f">
                Class Room
              </span>
            </div>

            <h1 className="text-[32px] leading-[1.05] sm:text-6xl lg:text-7xl font-heading font-extrabold text-white sm:leading-[1.05] mb-4 sm:mb-8 max-w-3xl" data-id="element-40" data-mp="2p63jw7n7polm">
              Todo tu año de clases de pádel{' '}
              <span className="text-cyan-400" data-id="element-41" data-mp="2z1y7lh6am9v9">resuelto.</span>
            </h1>

            {/* PRODUCT IMAGE */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.92
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="relative mb-6 sm:mb-10" data-id="element-42" data-mp="2u44yaf9p0zqr">
              <div className="absolute inset-0 bg-cyan-500/20 blur-3xl rounded-full scale-90" data-id="element-43" data-mp="18smtbozybf0s"></div>
              <img src="https://cdn.magicpatterns.com/uploads/idQcamCpECnLCfajXPgUnv/348.png" alt="PADEL 360 con los 12 Tomos y los 6 Bonus incluidos" width="576" height="576" fetchPriority="high" decoding="async" className="relative w-auto max-h-[34vh] sm:max-h-none sm:w-full sm:max-w-lg mx-auto h-auto drop-shadow-2xl" data-id="element-44" data-mp="38uw4hfymhnlb" />
            </motion.div>

            <p className="text-lg sm:text-2xl text-cyan-400 font-heading font-bold mb-4 max-w-2xl leading-snug" data-id="element-45" data-mp="kujgco2rngm">
              "Listo para usar. Sin improvisar. Sin perder domingos."
            </p>

            <p className="text-sm sm:text-lg text-slate-400 mb-7 max-w-xl leading-relaxed" data-id="element-46" data-mp="aanvtfw1k6lx">
              El sistema completo de planificación, drills y secuencias para el
              profesor de pádel: los 12 Tomos y los 6 Bonus, sin armar nada
              desde cero.
            </p>

            {/* Pills */}
            <div className="flex flex-wrap gap-2 sm:gap-3 mb-8 justify-center" data-id="element-47" data-mp="23vzjx5uo1hpp">
              <Pill icon="📄" text="PDF" data-id="element-48" data-mp="1yua47cwi0fva" />
              <Pill icon="⚡" text="Acceso inmediato" data-id="element-49" data-mp="1yxfsipxazdpy" />
              <Pill icon="🌎" text="Español neutro" data-id="element-50" data-mp="1uurjoi8la6sz" />
              <Pill icon="🎾" text="Todos los niveles" data-id="element-51" data-mp="1uvkt5qyxnaet" />
              <Pill icon="📚" text="12 Tomos + 6 Bonus" data-id="element-52" data-mp="1pvyfxhj3tu60" />
            </div>

            <button onClick={scrollToPricing} className="w-full sm:w-auto bg-cyan-500 hover:bg-cyan-400 text-slate-950 text-base sm:text-xl font-heading font-extrabold py-4 sm:py-5 px-8 sm:px-12 rounded-xl shadow-2xl shadow-cyan-500/25 transition-all hover:scale-[1.03] flex items-center justify-center gap-3 uppercase tracking-wide" data-id="element-53" data-mp="2ml5uu6p7x50y">
              💪 → QUIERO MI PADEL 360 AHORA
            </button>

            <div className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs sm:text-sm text-slate-500 font-medium" data-id="element-54" data-mp="36a7y1twr6moe">
              <span className="flex items-center gap-1.5" data-id="element-55" data-mp="2l25w48t7s69g">
                <ShieldCheck className="w-4 h-4 text-cyan-500" data-id="element-56" data-mp="2l4s3a7c70jr5" /> Garantía 7
                días
              </span>
              <span className="flex items-center gap-1.5" data-id="element-57" data-mp="2pze79pfy3a17">
                <Lock className="w-4 h-4 text-cyan-500" data-id="element-58" data-mp="2c3k4zp9ofix2" /> Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-59" data-mp="2h1vf813vvvft">
                <CreditCard className="w-4 h-4 text-cyan-500" data-id="element-60" data-mp="34qwt43vhjysh" /> Tarjetas y
                transferencia
              </span>
            </div>
          </motion.div>
        </div>

        {/* Trust Badges */}
        <div className="mt-16 sm:mt-20 pt-10 border-t border-white/10" data-id="element-61" data-mp="2v1d8ots4jwvi">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-62" data-mp="2uz0rwjy3rsk1">
            <div data-id="element-63" data-mp="2zy3p5i7ucuhg">
              <p className="text-3xl font-heading font-extrabold text-white" data-id="element-64" data-mp="2zxljxw37b5xe">
                +300
              </p>
              <p className="text-xs sm:text-sm text-slate-500 font-medium uppercase tracking-wider mt-1" data-id="element-65" data-mp="3sfz813yqjdja">
                profes en Latinoamérica
              </p>
            </div>
            <div data-id="element-66" data-mp="5najato3brn6">
              <p className="text-3xl font-heading font-extrabold text-white" data-id="element-67" data-mp="1obera69tww9">
                12+6
              </p>
              <p className="text-xs sm:text-sm text-slate-500 font-medium uppercase tracking-wider mt-1" data-id="element-68" data-mp="ffpyxkbx044w">
                Tomos + Bonus
              </p>
            </div>
            <div data-id="element-69" data-mp="3iw6whpihwson">
              <p className="text-3xl font-heading font-extrabold text-white" data-id="element-70" data-mp="3ivnde5h3zy91">
                4.9/5
              </p>
              <p className="text-xs sm:text-sm text-slate-500 font-medium uppercase tracking-wider mt-1" data-id="element-71" data-mp="3evmzqn1u3r31">
                calificación
              </p>
            </div>
            <div className="flex flex-col items-center justify-center" data-id="element-72" data-mp="3nvjf1y2c3dlf">
              <div className="flex text-yellow-400 mb-1" data-id="element-73" data-mp="3nxcm3eguzzty">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-74" data-mp="185ymjrp7zgqv" data-mpi={i} />)}
              </div>
              <p className="text-xs sm:text-sm text-slate-500 font-medium uppercase tracking-wider" data-id="element-75" data-mp="1b5qo5nkm9ckq">
                profes satisfechos
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 2 - INITIAL TESTIMONIALS */}
      <section className="py-16 sm:py-20 bg-court-panel px-4 sm:px-6 lg:px-8 border-y border-white/5" data-id="element-76" data-mp="1k6y7mzih48ur">
        <div className="max-w-7xl mx-auto" data-id="element-77" data-mp="1p4qc0t0b1nfu">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-78" data-mp="ri13s1f0eelj">
            <TestimonialCard initials="MP" quote="Organicé todo el mes de clases en una tarde. Nunca más llego a la cancha sin saber qué drill voy a dar." name="Martín P., Buenos Aires" role="Profesor de Pádel en Club Privado" data-id="element-79" data-mp="rfocuyr9wtwc" />
            <TestimonialCard initials="CG" quote="Mis alumnos de nivel inicial mejoraron su posición en cancha desde la primera semana con el Tomo 2. Nunca había visto eso tan rápido." name="Carolina G., Bogotá" role="Profesora de Pádel Independiente" data-id="element-80" data-mp="168qg5747hzqz" />
            <TestimonialCard initials="FR" quote="Antes tardaba 1 hora armando la clase. Ahora abro el tomo que corresponde y en 5 minutos estoy listo." name="Federico R., Santiago" role="Profesor de Pádel en Academia" data-id="element-81" data-mp="17qvfk5dukcx" />
          </div>
        </div>
      </section>

      {/* SECTION 3 - PAIN SECTION */}
      <section className="py-20 bg-court-night px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-82" data-mp="3jeoiqbf8kadq">
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-83" data-mp="3elc5exg0bq0a">
          <h2 className="text-2xl sm:text-4xl font-heading font-extrabold mb-12 text-center text-white leading-tight" data-id="element-84" data-mp="39mr4swwuf4bb">
            Si eres profe de pádel, esto te va a{' '}
            <span className="text-cyan-400" data-id="element-85" data-mp="2zp4l7x4lmol0">sonar conocido:</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-14" data-id="element-86" data-mp="2zr79ocq3s9nm">
            <PainPoint text="Llegas a la cancha sin saber exactamente qué drill vas a dar hoy" data-id="element-87" data-mp="2voawj1jc15r2" />
            <PainPoint text="Tus alumnos no progresan porque no hay un orden claro de contenidos" data-id="element-88" data-mp="nfm8xb1cq87k" />
            <PainPoint text="Tienes grupos con niveles mezclados y no sabes cómo manejarlos" data-id="element-89" data-mp="sdnty1ic8hlo" />
            <PainPoint text="Un alumno falta 2 semanas y pierdes la continuidad de todo el grupo" data-id="element-90" data-mp="dgdkexp99lsl" />
            <PainPoint text="No puedes justificar un aumento de precio porque no tienes nada sistematizado" data-id="element-91" data-mp="ief1jd34fb1f" />
            <PainPoint text="El domingo por la noche te llega la ansiedad sin saber qué dar el lunes" data-id="element-92" data-mp="4na9aw231l14" />
            <PainPoint text="Repites los mismos drills una y otra vez porque no tienes más variantes y los alumnos se aburren" data-id="element-93" data-mp="9gmoygosahhq" />
            <PainPoint text="Nadie valora tu trabajo porque no se refleja en un progreso concreto y visible" data-id="element-94" data-mp="3vuwbek95lffv" />
          </div>

          <div className="text-center bg-white/[0.03] p-8 sm:p-10 rounded-2xl border border-white/10" data-id="element-95" data-mp="3huv8kz9bvxxr">
            <h3 className="text-2xl sm:text-4xl font-heading font-extrabold text-cyan-400 mb-8" data-id="element-96" data-mp="3lvnhfreag0ti">
              "¿Cuántas clases más vas a improvisar?"
            </h3>

            <button onClick={scrollToPricing} className="w-full sm:w-auto bg-cyan-500 hover:bg-cyan-400 text-slate-950 text-base sm:text-xl font-heading font-extrabold py-4 sm:py-5 px-8 rounded-xl shadow-2xl shadow-cyan-500/25 transition-all hover:scale-[1.03] flex items-center justify-center gap-3 uppercase mx-auto" data-id="element-97" data-mp="2y9l8gwvwwz2e">
              👉 BASTA DE IMPROVISAR
            </button>
          </div>
        </div>
      </section>
    </div>;
}
function Pill({
  icon,
  text
}: {
  icon: string;
  text: string;
}) {
  return <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white/5 border border-white/10 text-slate-300 rounded-full text-xs sm:text-sm font-medium" data-id="element-98" data-mp="3uz2oo5siu3ic">
      <span data-id="element-99" data-mp="8ruk35pfe0nd">{icon}</span>
      {text}
    </span>;
}
function TestimonialCard({
  initials,
  quote,
  name,
  role
}: {
  initials: string;
  quote: string;
  name: string;
  role: string;
}) {
  return <div className="bg-white/[0.03] rounded-2xl p-7 border border-white/10" data-id="element-100" data-mp="2qsv3zid7kfx2">
      <div className="flex items-center gap-4 mb-5" data-id="element-101" data-mp="2m251ccw62r62">
        <div className="w-11 h-11 rounded-full bg-cyan-500/15 text-cyan-400 flex items-center justify-center font-bold" data-id="element-102" data-mp="2m0bp8i2sbeqo">
          {initials}
        </div>
        <div className="flex text-yellow-400" data-id="element-103" data-mp="2d1qcj3jzutxt">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-104" data-mp="39r7fharle1vt" data-mpi={i} />)}
        </div>
      </div>
      <p className="text-slate-300 mb-5 leading-relaxed" data-id="element-105" data-mp="35q5fgrpuplss">"{quote}"</p>
      <div data-id="element-106" data-mp="35nriuefiw1j4">
        <p className="font-bold text-white text-sm" data-id="element-107" data-mp="30qssm6yzceq7">{name}</p>
        <p className="text-xs text-slate-500 mt-0.5" data-id="element-108" data-mp="30p7wicx0onq8">{role}</p>
      </div>
    </div>;
}
function PainPoint({
  text
}: {
  text: string;
}) {
  return <div className="flex items-start gap-3 bg-white/[0.03] p-5 rounded-xl border border-white/[0.07]" data-id="element-109" data-mp="1pbckhd1esv38">
      <XCircle className="w-5 h-5 text-red-400/80 flex-shrink-0 mt-0.5" data-id="element-110" data-mp="1kcsy5biwlhac" />
      <p className="text-slate-300 leading-snug" data-id="element-111" data-mp="1kevu0c6qm4mz">{text}</p>
    </div>;
}